// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, css, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, state, property } from 'lit/decorators.js';
import LightElement from './light-element.js';
import Helpers from '../../typescript/modules/helpers.js';
import Logger from '../../typescript/modules/logger.js';

@customElement('product-comparison-add')
export default class ProductComparisonAdd extends LightElement {

	private productComparisonIdsKey: string = 'productComparisonIds';

	@property()
	parentId: string;

	@property()
	productId: string;

	@property({ type: Function })
	onSelected: () => void;

	@property({ type: Boolean })
	disable: boolean;

	connectedCallback() {
		super.connectedCallback();
	}

	private selectProduct() {

		if (this.disable) {
			return;
		}

		const updateProductComparisonEvent = Helpers.createCustomEventForDispatch('productComparisonVariantSelected', {
			productId: this.productId,
			parentId: this.parentId
		});
		document.dispatchEvent(updateProductComparisonEvent);

		this.onSelected();
	}

	render() {
		return html`
			<button type="button" class="c-button c-button--emphasize c-button--large c-add-product__button" @click="${this.selectProduct.bind(this)}" data-test="product-viewer-compare-button">
				Select for comparison
			</button>
	`;
	}
}
